module.exports = __webpack_public_path__ + "img/xhl.54f621ca.jpg";